import React, { Component } from 'react';
import Select from 'react-select';
import ValidatedInput from '../forms/ValidatedInput';
import RadioWithLabel from '../forms/RadioWithLabel';
import i18n from '../../i18n';
import ValidatedControl from '../forms/ValidatedControl';
import constants from '../../constants';

class TapTypeSelector extends Component {
    constructor(props) {
        super(props);
        this.scrollModalToBottom = this.scrollModalToBottom.bind(this);
    }

    scrollModalToBottom() {
        const contentModal = document.querySelector('.large-modal-scroll-wrapper');
        if (!contentModal) return;

        const isScrollable = contentModal?.scrollHeight > contentModal?.clientHeight;

        if (isScrollable) {
            requestAnimationFrame(() => {
                contentModal.scrollTop = contentModal.scrollHeight;
            });
        }
    };

    render() {
        const selectedForm = this.props.formsObjects.filter((form) => { return form.id === this.props.contentModalContent.tapDestination; })[0];
        const selectedFormNotSubmittable = selectedForm ? selectedForm.isSubmittable !== true : false;
        

        return (
            <div className="tap-type">
                <h4>{i18n.t('pages.tapTypeHeader')}</h4>

                <div className="stacked-radio">
                    {constants.ContentType.find((c) => {
                        return c.Id === this.props.contentModalContent.contentType;
                    })?.Name !== 'LinkButton'
                        && (
                            <RadioWithLabel
                                id="tap-type-1"
                                name="tap-type"
                                handleClick={() => {
                                    return this.props.updateTapTypeFromEvent(1);
                                }}
                                defaultChecked={this.props.contentModalContent.tapType === 1}
                                text={i18n.t('pages.tapType1')}
                                value={1}
                            />
                        )}
                    <RadioWithLabel
                        id="tap-type-2"
                        name="tap-type"
                        handleClick={() => {
                            return this.props.updateTapTypeFromEvent(2);
                        }}
                        defaultChecked={this.props.contentModalContent.tapType === 2}
                        text={i18n.t('pages.tapType2')}
                        value={2}
                    />
                    {this.props.contentModalContent.tapType === 2
                        && (
                            <div className="tap-pages">
                                <ValidatedControl
                                    containerClass="tap-type pageSelector"
                                    hasError={false}
                                    errorMessage=""
                                    hasInfo={this.props.contentModalContent.tapDestination === '5'}
                                    infoMessage="A new page will be added to Pages"
                                    hasWarning={false}
                                    warningMessage=""
                                    hasSuccess={false}
                                    successMessage=""
                                >
                                    <Select
                                        options={this.props.pagesItems}
                                        className="form-selector pages-selector"
                                        classNamePrefix="form-selector"
                                        value={this.props.pagesItems.length > 0 ? this.props.pagesItems.find((f) => { return f.value === this.props.contentModalContent.tapDestination; }) : ''}
                                        onChange={(e) => {
                                            return this.props.setStateFromEvent(e, 'tapDestination');
                                        }}
                                        clearable={false}
                                        searchable
                                        placeholder={i18n.t('selectPlaceholder')}
                                        onMenuOpen={this.scrollModalToBottom}
                                    />
                                </ValidatedControl>
                            </div>
                        )}
                    <RadioWithLabel
                        id="tap-type-3"
                        name="tap-type"
                        handleClick={() => {
                            return this.props.updateTapTypeFromEvent(3);
                        }}
                        defaultChecked={this.props.contentModalContent.tapType === 3}
                        text={i18n.t('pages.tapType3')}
                        value={3}
                    />
                    {this.props.contentModalContent.tapType === 3
                        && (
                            <ValidatedControl
                                containerClass="tap-type fmsSelector"
                                hasError={false}
                                errorMessage
                                hasWarning={selectedFormNotSubmittable}
                                warningMessage="Selected form is not active for submissions"
                                hasSuccess={false}
                                successMessage=""
                            >
                                <Select
                                    options={this.props.formsItems}
                                    className="form-selector"
                                    classNamePrefix="form-selector"
                                    value={this.props.formsItems.length > 0 ? this.props.formsItems.find((f) => { return f.value === this.props.contentModalContent.tapDestination; }) : ''}
                                    onChange={(e) => {
                                        return this.props.setStateFromEvent(e, 'tapDestination');
                                    }}
                                    clearable={false}
                                    searchable
                                    placeholder={i18n.t('selectPlaceholder')}
                                    onMenuOpen={this.scrollModalToBottom}
                                />
                            </ValidatedControl>
                        )}
                    <RadioWithLabel
                        id="tap-type-4"
                        name="tap-type"
                        handleClick={() => {
                            return this.props.updateTapTypeFromEvent(4);
                        }}
                        defaultChecked={this.props.contentModalContent.tapType === 4}
                        text={i18n.t('pages.tapType4')}
                        value={4}
                    />
                    {this.props.contentModalContent.tapType === 4
                        && (
                            <ValidatedInput
                                containerClass="input_tapDestination"
                                labelText={i18n.t('pages.tapType4Label')}
                                value={this.props.contentModalContent.tapDestination}
                                placeholder={i18n.t('pages.tapType4Label')}
                                name="headerText"
                                onChange={(e) => {
                                    return this.props.setStateFromEvent(e, 'tapDestination');
                                }}
                                errorMessage=""
                                hasError={false}
                                successMessage=""
                                hasSuccess={false}
                            />
                        )}
                </div>
            </div>
        );
    }
}

export default TapTypeSelector;
